<ion-app>
    <ion-split-pane contentId="content" when="true">
        <ion-menu [hidden]="!authUser?.userId" side="end" contentId="content" menuId="first" type="overlay">
            <ion-header>
                <ion-toolbar>
                    <ion-menu-toggle>
                        <ion-item style="--inner-padding-end: 0px;" lines="none" button [routerLink]="['/my-profile']"
                            routerLinkActive="/my-profile" routerDirection="forward">

                            <ion-avatar slot="start"
                                style="width: 50px; height: 50px; border-radius: 50%; margin-right: 5px;">
                                <ng-container *ngIf="authUser?.profile_image; else defaultAvatar">
                                    <img [src]="authUser?.profile_image" alt="Profile Image">
                                </ng-container>
                                <ng-template #defaultAvatar>
                                    <ion-icon name="person-circle-outline" style="font-size: 50px;"></ion-icon>
                                </ng-template>
                            </ion-avatar>

                            <ion-label class="ion-text-wrap">
                                {{ authUser?.last_name?.toUpperCase() + ', ' + authUser?.first_name }}
                                <p>{{ authUser?.phone }}</p>
                            </ion-label>

                        </ion-item>
                    </ion-menu-toggle>
                </ion-toolbar>
            </ion-header>
            <ion-content>
                <ion-menu-toggle>
                    <app-main-menu></app-main-menu>
                </ion-menu-toggle>
            </ion-content>
            <ion-footer>
                <ion-toolbar>
                    <ion-item lines="none" color="none">
                        @if (version) {
                        <div class="version">
                            v. {{ version }}
                        </div>
                        }
                        <ion-button (click)="openSocial('facebook')" fill="clear" slot="end">
                            <ion-icon slot="icon-only" name="logo-facebook"></ion-icon>
                        </ion-button>
                        <ion-button (click)="openSocial('instagram')" fill="clear" slot="end">
                            <ion-icon slot="icon-only" name="logo-instagram"></ion-icon>
                        </ion-button>
                        <ion-button (click)="openSocial('twitter')" fill="clear" slot="end">
                            <ion-icon slot="icon-only" name="logo-twitter"></ion-icon>
                        </ion-button>
                    </ion-item>
                </ion-toolbar>
            </ion-footer>
        </ion-menu>
        <ion-router-outlet id="content"></ion-router-outlet>
    </ion-split-pane>

    <!-- ✅ Offline Modal: Show globally -->
    <!-- <div *ngIf="!isOnline" class="offline-modal">
        <div class="offline-card">
            <h2>Internet connection is lost</h2>
            <p>Please connect to the internet to ensure the app functions properly</p>
            <ion-button fill="clear" color="primary" (click)="dismissOffline()">Dismiss</ion-button>
        </div>
    </div> -->
</ion-app>